import { render } from "./receiveLoanpayment.vue?vue&type=template&id=2b285b71&scoped=true"
import script from "./receiveLoanpayment.vue?vue&type=script&lang=js"
export * from "./receiveLoanpayment.vue?vue&type=script&lang=js"

import "./receiveLoanpayment.vue?vue&type=style&index=0&id=2b285b71&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/raiseloans/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b285b71"]])

export default __exports__